import React from 'react';
import MiniHeaders from "./mini-headers";
import Button from '@mui/material/Button';
import "../components-css/how-register.scss"
import regGif from "../assets/images/anim.gif"
import {useNavigate} from "react-router-dom";

const HowRegister = () => {
    const navigate = useNavigate();

    return (
        <div className={'blocks-wrapper'}>
            <MiniHeaders headerName={'Ինչպես գրանցվել'}/>
            <h4>Գրանցումը հաստատվում է դասընթացի արժեքի ամբողջական կամ մասնակի վճարումով։</h4>
            <br/>
            <h4>Գործում է վճարման 2 տարբերակ՝</h4>
            <br/>
            <ol className={'course'}>
                <p>
                    <li>
                        Դասընթացին գրանցվելիս վճարում եք կանխավճար, որը կազմում է 20000 դրամ Ձեր տեղն ամրագրելու
                        համար, իսկ գումարի մնացած
                        մասը վճարում եք մինչև 4-րդ դաս։
                    </li>
                </p>
                <br/>
                <p>
                    <li>
                        Rocket Line, որը ձեռք եք բերում ID բանկի միջոցով շատ արագ և հեշտ։ Սովորում եք հիմա, վճարում՝
                        3-6 ամիսների ընթացքւմ բանկին։
                    </li>
                </p>
            </ol>
            <br/>
            <div className={'register-button'}>
                <Button variant="outlined" style={{padding: 7}} size="large" onClick={()=>navigate("/register")}>
                   Գրանցվել
                    <img style={{marginLeft: 6}} src={regGif} alt="Approved"
                         title="Approved" width="36" height="36"/>
                </Button>
            </div>
        </div>
    );
};

export default HowRegister;
